import React from "react";

interface CriteriaConjunctionToggleProps {
  value: "AND" | "OR";
  onChange: (value: "AND" | "OR") => void;
  disabled?: boolean;
}

/**
 * AND / OR pill toggle for group conjunctions. Internal to CriteriaTreeBuilder.
 */
const CriteriaConjunctionToggle = ({
  value,
  onChange,
  disabled = false,
}: CriteriaConjunctionToggleProps) => {
  const optionClass = (option: "AND" | "OR") =>
    [
      "criteria-tree-builder__conjunction-option",
      option === value ? "criteria-tree-builder__conjunction-option--active" : "",
      disabled ? "criteria-tree-builder__conjunction-option--disabled" : "",
    ]
      .filter(Boolean)
      .join(" ");

  return (
    <div
      className="criteria-tree-builder__conjunction"
      role="group"
      aria-label="Group conjunction"
    >
      <button
        type="button"
        className={optionClass("AND")}
        onClick={() => !disabled && onChange("AND")}
        aria-pressed={value === "AND"}
        disabled={disabled}
      >
        AND
      </button>
      <button
        type="button"
        className={optionClass("OR")}
        onClick={() => !disabled && onChange("OR")}
        aria-pressed={value === "OR"}
        disabled={disabled}
      >
        OR
      </button>
    </div>
  );
};

export default CriteriaConjunctionToggle;